module.exports = __webpack_public_path__ + "img/two1Red.c59f2d7a.jpg";